
export default {
  data() {
    return {
      // 币制列表
      currencySystemList: [
        { id: 'CNY', name: '人民币' },
        { id: 'USD', name: '美元' }
      ],
      currencySystemObj: {
        'CNY': '人民币',
        'USD': '美元'
      },

    }
  },
  created() {
  },
  methods: {
  }
}